import ActionTypes from '@/actions/ActionTypes';

const { SECTOR__REMOVE, SECTOR__BATCH_ADD } = ActionTypes;

const initialState = {
  all: [],
};

export default function (state = initialState, action: any) {
  switch (action.type) {
    case SECTOR__REMOVE:
      return {
        ...state,
        // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
        all: state.all.filter((p) => p.id !== action.id),
      };
    case SECTOR__BATCH_ADD:
      return {
        ...state,
        all: action.sectors,
      };
    default:
      return state;
  }
}
